import React from "react";

const Footer = () => {
  const d = new Date();
  let year = d.getFullYear();
  return (
    <footer className="footer">
      <div className="copyright">&copy; Plugit {year} </div>
      <div className="socials">
        <a
          href="https://instagram.com/runplugit?igshid=YmMyMTA2M2Y="
          class="d-flex align-items-center justify-content-center"
          target="_blank"
        >
          <i class="fa fa-instagram"></i>
        </a>
        <a
          href="https://twitter.com/Runplugit?t=qYGuf8fLJca2oAbGUlbaRA&s=09"
          class="d-flex align-items-center justify-content-center"
          target="_blank"
        >
          <i class="fa fa-twitter"></i>
        </a>

        <a
          href="https://www.linkedin.com/company/plugit-automation/"
          class="d-flex align-items-center justify-content-center"
          target="_blank"
        >
          <i class="fa fa-linkedin"></i>
        </a>
        {/* <a
          href="https://instagram.com/runplugit?igshid=YmMyMTA2M2Y="
          class="d-flex align-items-center justify-content-center"
          target="_blank"
        >
          <i class="fa fa-facebook"></i>
        </a> */}
      </div>
    </footer>
  );
};

export default Footer;
